import type { ProductKey } from "@/lib/billing/entitlements";

export type BundleTierId = "silver" | "gold" | "diamond";

export const BUNDLE_TIER_ORDER: readonly BundleTierId[] = ["silver", "gold", "diamond"];

export const BUNDLE_ENTITLEMENTS: Record<BundleTierId, readonly ProductKey[]> = {
  silver: ["ev-plan"],
  gold: ["ev-plan", "whale-watch"],
  diamond: ["ev-plan", "whale-watch", "ev-sniper"],
};

export function isBundleTierId(value: string): value is BundleTierId {
  return value === "silver" || value === "gold" || value === "diamond";
}

export function getBundleEntitlements(tier: BundleTierId): readonly ProductKey[] {
  return BUNDLE_ENTITLEMENTS[tier];
}

export function isEntitlementSuperset(
  candidateEntitlements: readonly ProductKey[],
  requiredEntitlements: ReadonlySet<ProductKey>,
): boolean {
  return Array.from(requiredEntitlements).every((entitlement) =>
    candidateEntitlements.includes(entitlement),
  );
}

export function findMinimumBundleForEntitlements(
  requiredEntitlements: ReadonlySet<ProductKey>,
  availableBundleIds: ReadonlySet<BundleTierId> = new Set(BUNDLE_TIER_ORDER),
): BundleTierId | null {
  for (const tierId of BUNDLE_TIER_ORDER) {
    if (!availableBundleIds.has(tierId)) continue;
    if (isEntitlementSuperset(getBundleEntitlements(tierId), requiredEntitlements)) {
      return tierId;
    }
  }

  return null;
}
